import React from 'react';
import PropTypes from 'prop-types';
import TinymceEditor from 'components/common/TinymceEditor';
import RecipientSelect from 'components/common/select/RecipientSelect';

const EmailField = ({ label, value, onChange }) => (
  <div className="tw-grid tw-grid-cols-[56px_1fr] tw-items-start tw-gap-2 tw-px-3 tw-py-2 tw-border-b tw-border-slate-100">
    <label className="tw-text-[10px] tw-font-bold tw-uppercase tw-tracking-wider tw-text-slate-500 tw-pt-3">{label}</label>
    <RecipientSelect value={value} onChange={onChange} placeholder="Search employee or type email..." />
  </div>
);

const ForecastEmailFields = ({ toEmails, ccEmails, subject, body, onToChange, onCcChange, onSubjectChange, onBodyChange }) => (
  <div className="tw-space-y-3">
    <div className="tw-border tw-border-slate-200 tw-rounded tw-overflow-hidden tw-bg-white">
      <EmailField label="To" value={toEmails} onChange={onToChange} />
      <EmailField label="CC" value={ccEmails} onChange={onCcChange} />
      <div className="tw-grid tw-grid-cols-[56px_1fr] tw-items-center tw-gap-2 tw-px-3 tw-py-2">
        <label className="tw-text-[10px] tw-font-bold tw-uppercase tw-tracking-wider tw-text-slate-500">Subject</label>
        <input value={subject} onChange={(event) => onSubjectChange(event.target.value)} className="tw-w-full tw-border-0 tw-outline-none tw-text-xs tw-font-medium" />
      </div>
    </div>
    {/* TinymceEditor's change prop is `handleChange` — `onEditorChange` silently
        dropped every keystroke, so composed text never reached the form state. */}
    <TinymceEditor value={body} handleChange={onBodyChange} height="220px" resizable minHeight={160} maxHeight={620} />
  </div>
);

EmailField.propTypes = { label: PropTypes.string, value: PropTypes.array, onChange: PropTypes.func };
ForecastEmailFields.propTypes = {
  toEmails: PropTypes.array, ccEmails: PropTypes.array, subject: PropTypes.string, body: PropTypes.string,
  onToChange: PropTypes.func, onCcChange: PropTypes.func, onSubjectChange: PropTypes.func, onBodyChange: PropTypes.func,
};

export default ForecastEmailFields;
